module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/conservation-5d0f3adac937a720304b7a6af01f4970.png";